export default __webpack_public_path__ + "static/media/banner-img.427b0e51.jpg";